import type { IconSvgObject } from './types';

const CollectionsBookmarkIcon: IconSvgObject = [
  ["rect", { x: "3", y: "5.5", width: "15", height: "16", rx: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 2.5H19C20.1046 2.5 21 3.39543 21 4.5V16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10 5.5V11.5L12.5 9.5L15 11.5V5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CollectionsBookmarkIcon;
